module.exports = __webpack_public_path__ + "static/media/Icon_Goto.e0203e7c.svg";